export const WHITE_LABEL = 'WHITE_LABEL';
export const CUSTOM_BRANDING = 'CUSTOM_BRANDING';
export const MODIFY_MENU = 'MODIFY_MENU';
export const LIVE_TRANSLATIONS = 'LIVE_TRANSLATIONS';
export const USAGE_STATS = 'USAGE_STATS';
export const REMEDIATION = 'REMEDIATION';
export const UW_CURRENCY_USD = 'USD';

export const INITIAL_PAGE_STATE = 'main.home';
export const REPORT_PAGE_STATE = 'main.report';
export const MOVE_HIDE_STATE = 'main.manage';
export const LANGUAGES_STATE = 'main.languages';
export const ABOUT_STATE = 'main.about';
export const HOW_IT_WORKS_STATE = 'main.how_it_works';
